import { render, staticRenderFns } from "./OssResult.vue?vue&type=template&id=e3ec7f7e&scoped=true&"
import script from "./OssResult.vue?vue&type=script&lang=js&"
export * from "./OssResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ec7f7e",
  null
  
)

export default component.exports